import { useEffect, useState } from "react";
import { History } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";

const ACTION_LABELS = {
  site_created: "Service ajouté",
  site_updated: "Rôles modifiés",
  site_deleted: "Service supprimé",
  national_admins_updated: "Administrateurs Nationaux modifiés",
};

export default function AuditLogDialog() {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api
      .get("/users/audit-log")
      .then((res) => setEntries(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" data-testid="open-audit-log-button">
          <History className="h-4 w-4" />
          Historique
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="audit-log-dialog">
        <DialogHeader>
          <DialogTitle>Historique des modifications</DialogTitle>
          <DialogDescription>Les 100 dernières modifications de rôles et d'accès.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {loading && <p className="text-sm text-muted-foreground text-center py-6">Chargement...</p>}
          {!loading && entries.length === 0 && (
            <p className="text-sm text-muted-foreground text-center py-6" data-testid="audit-log-empty">
              Aucune modification enregistrée.
            </p>
          )}
          {entries.map((e) => (
            <div key={e.id} className="border border-border rounded-md p-3 text-sm" data-testid={`audit-log-entry-${e.id}`}>
              <div className="flex items-center justify-between gap-2 mb-1">
                <Badge variant="secondary" className="text-[10px]">
                  {ACTION_LABELS[e.action] || e.action}
                </Badge>
                <span className="text-xs text-muted-foreground">
                  {new Date(e.timestamp).toLocaleString("fr-FR")}
                </span>
              </div>
              <p className="text-foreground">{e.summary}</p>
              <p className="text-xs text-muted-foreground mt-1">
                Par {e.actor_name || e.actor_email} ({e.actor_email})
              </p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
